import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// Global Production Override for API Connections
if (import.meta.env.PROD) {
  const nativeFetch = window.fetch;
  const apiUrl = (import.meta.env.VITE_API_URL || "https://eliadadeploynew.onrender.com").replace(/\/$/, "");

  window.fetch = async function (input: RequestInfo | URL, init?: RequestInit) {
    let rawUrl = typeof input === "string" ? input : input instanceof Request ? input.url : String(input);
    
    try {
      const parsedUrl = new URL(rawUrl, window.location.origin);
      if (parsedUrl.pathname.startsWith("/api")) {
        const fullTargetUrl = `${apiUrl}${parsedUrl.pathname}${parsedUrl.search}`;
        if (input instanceof Request) {
          input = new Request(fullTargetUrl, init || input);
        } else {
          input = fullTargetUrl;
        }
      }
    } catch (e) {
      console.warn("API URL parse error:", e);
    }

    const response = await nativeFetch(input, init);

    const contentType = response.headers.get("content-type");
    const reqUrl = typeof input === "string" ? input : input instanceof Request ? input.url : String(input);

    if (contentType && contentType.includes("text/html") && reqUrl.includes("/api")) {
      console.warn("Intercepted HTML fallback from API endpoint:", reqUrl);
      return new Response(JSON.stringify([]), {
        status: 200,
        headers: { "Content-Type": "application/json" },
      });
    }

    return response;
  };
}

createRoot(document.getElementById("root")!).render(<App />);
